import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import { appConstant, THEME, productOnboardStatus } from "Util/constants";
import { useParams, useLocation } from "react-router-dom";
import {
  Form,
  Input,
  InputNumber,
  notification,
  Select,
  Switch
} from "antd";
import { PlusOutlined } from '@ant-design/icons';
import CommonDiv from "Components/CommonDiv";
import CommonButton, { ButtonLoader } from "Components/CommonButton";
import { useQuery, useLazyQuery, useMutation } from "@apollo/client";
import { GET_PRODUCTS, GET_BUYER_PRODUCT_DETAILS, GET_DROPDOWN_SPEC_DATA } from "Util/queries";
import _ from "lodash";
import { ADD_BUYER_PRODUCTS, ADD_BUYER_PRODUCTS_IMAGES} from "Util/mutations";
import { useHistory } from "react-router-dom";
import TextArea from "antd/lib/input/TextArea";
import ChooseUom from "./components/ChooseUom";
import ChooseProduceType from "./components/ChooseProduceType";
import ChooseProductEnvironment from "./components/ChooseProductEnvironment";
import ChooseProduceSubCat from "./components/ChooseProduceSubCat";
import ChooseProduceSizing from "./components/ChooseProduceSizing";
import ChooseProcessCat from "./components/ChooseProcessCat";
import ChooseGenProdPostGrp from "./components/ChooseGenProdPostGrp";
import ChooseInventoryPostingGroup from "./components/ChooseInventoryPostingGroup";
import ChooseGstProdPostGrp from "./components/ChooseGstProdPostGrp";
import ChooseSpecies from "./components/ChooseSpecies";
import CatchMethodDropdown from "./components/CatchMethodDropdown";
import FormatDropdown from "./components/FormatDropdown";
import { uploadImage } from "Util/imageUploaderS3";
import { v4 as uuidv4 } from 'uuid';
import { CardHeader } from "./components/ProductCard";
const { Option } = Select;


const Container = styled.div``;

const SectionContainer = styled.div`
	.content {
		margin: 5px;
		display: flex;
		justify-content: space-between;
		& > div.division {
			width: calc(50% - 30px);
			.ant-form-item-label > label {
				width: 190px;
			}
			.ant-form-item-control {
				width: 10px;
			}
		}
	}
	.division-title {
		font-weight: bold;
	}

  .header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }

	.ant-switch-checked {
		background-color: ${THEME.colors.primary};
	}
`;

const Section = (props) => {
  return (
    <SectionContainer>
      <h3 style={{ borderBottom: "solid thin #000", padding: "5px" }}>
        {props.title}
      </h3>
      <div className="content">{props.children}</div>
    </SectionContainer>
  );
};
function WholesaleNewProductPage(props) {
  const [form] = Form.useForm();
  const params = useParams();
  const routeLocation = useLocation();
  const history = useHistory();
  //const editMode = routeLocation.pathname.includes("/product-list/new/edit");
  const [editMode, setEditMode] = useState(routeLocation.pathname.includes("/product-list/new/edit"))
  const [formLoading, setFormLoading] = useState(false);
  const [img, setImg] = useState(null);
  const [origImg, setOrigImg] = useState(null);
  const [allProducts, setAllProducts] = useState([])
  const imageRef = useRef(null)
  const [category, setCategory] = useState('');

  const { data: specData, loading: specLoading, error: specError } = useQuery(GET_DROPDOWN_SPEC_DATA);
  const dropdowns =
    category === 'Fish'
      ? specData?.fish[0]?.values || {}
      : category === 'Non Fish'
        ? specData?.nonFish[0]?.values || {}
        : {};

  //TODO: make specification templates dynamic
  //const templates = specData?.specification_templates;
  //const activeSpecs = templates?.filter((t) => t.category === category);

  const [getProduct, { loading, error, data, refetch, networkStatus }] =
    useLazyQuery(GET_BUYER_PRODUCT_DETAILS,
      {
        onError(error) {
        },
        onCompleted() {
          const product_info = data.buyer_db.products?.[0]

          setImg(product_info?.images[0]?.uri)
          setOrigImg(product_info?.images[0]?.uri)
          const specsObject = {};
          product_info.specifications.forEach(({ key, value }) => {
              specsObject[key] = value;
          });
          setCategory(product_info.product_sub_category)

          setItemCodes({
            produce_type: {
              code: product_info.produce_type,
              // description: product_info.species_type?.description
            },
            produce_environment: {
              code: product_info.produce_environment,
              // description: product_info.species_environment?.description
            },
            product_sub_category: {
              code: product_info.product_sub_category,
              // description: product_info.species_sub_category?.description
            },
            label: {
              code: product_info.label,
              // description: product_info.label
            },
            produce_sizing: {
              code: product_info.produce_sizing,
              // description: product_info.species_sizing?.description
            },
            process_category: {
              code: product_info.process_category,
              // description: product_info.processCategoryByProcessCategory?.description
            }
          })

          form.setFieldsValue({
            ...product_info,
            specifications: specsObject,
            process_category: product_info.process_category,
            produce_environment: product_info.produce_environment,
            produce_sizing: product_info.produce_sizing,
            product_sub_category: product_info.product_sub_category,
            produce_type: product_info.produce_type,
            species_name: product_info.label
          });
        },
      });
  
  const {data: all_products} = useQuery(GET_PRODUCTS, {
        onCompleted() {
            setAllProducts(all_products.products)
        }
  });

  const [add, {error: addError}] = useMutation(ADD_BUYER_PRODUCTS, {
    onCompleted(data) {
      setFormLoading(false);

      const { returning } = data.buyer_db.insert_products

      editMode && notification["success"]({
        message: "Saved!",
        description: "Product Updated!",
      });

      if (!editMode){
        notification["success"]({
          message: "Saved!",
          description: "Product Saved!",
        });
        setEditMode(true)
        getProduct({
          variables: { id: returning[0].id },
        });
        history.push(`/wholesale/product-list/new/edit/${returning[0].id}`, { prevPath: '/wholesale/product-list'})
      }
    }
  });

  const [addProductImages] = useMutation(ADD_BUYER_PRODUCTS_IMAGES)

  useEffect(() => {
    if (editMode) {
      getProduct({
        variables: { id: params.id },
      });
    } else {
      form.setFieldsValue({
        partner_type: params.type,
      });
    }
  }, []);

  const submitHandler = async (values) => {

    const { specifications, species_name, species_inventories, ...rest } = values;
    setFormLoading(true);
    // const species_cost_posting = { ...values.species_cost_posting }
    // const species_inventories = { ...values.species_inventories }
    // const species_item_trackings = { ...values.species_item_trackings }
    // const species_plannings = { ...values.species_plannings }
    // const species_pricing_and_sales = { ...values.species_pricing_and_sales }
    // const species_replenishments = { ...values.species_replenishments }
    // const species_warehouses = { ...values.species_warehouses }

    // delete values['species_cost_posting']
    //delete values['species_inventories']
    // delete values['species_item_trackings']
    // delete values['species_plannings']
    // delete values['species_pricing_and_sales']
    // delete values['species_replenishments']
    //delete values['species_name']

    // rest.process_category = itemCodes.process_category
    // rest.produce_environment = itemCodes.produce_environment
    // rest.produce_sizing = itemCodes.produce_sizing
    // rest.product_sub_category = itemCodes.product_sub_category
    // rest.produce_type = itemCodes.produce_type

    //TODO: delete these columns in db
    rest.tags = [ "frozen" ]
    rest.format = 'Frozen'
    rest.grade = 'G4 Premium'
    rest.count = '20'
    rest.avg_pouch_weight = '30'
    rest.glaze_perc = '30'
    rest.size_text = 'SMA'
    rest.size = '100'
    rest.avg_carton_weight = '30'
    rest.price = '150'
    rest.count_type = 'FWFC'
    rest.quantity = '2000'
    rest.moq = '10'
    rest.origin_country = 'India'
    rest.species_id = '2000'

    const formSpecs = values.specifications || {};
    const specsArray = Object.entries(specifications).map(([key, value]) => ({
      key,
      value: typeof value === 'object' && value !== null ? JSON.stringify(value) : String(value),
    }));


    if (warningMessage){
      values.id = warningMessage.id ?? undefined
    }

    let image = origImg || img;

    if (!_.isUndefined(imageRef.current.files[0])) {
      const file = imageRef.current.files[0];
      let existingImageId = null;

      if(editMode && origImg){
        const parts = origImg.split('/')
        const lastPart = parts[parts.length - 1]
        existingImageId = lastPart.replace(/\.(png|jpg)$/, "")
      }
      const imageId = existingImageId ?? uuidv4()

      const postData = {
        filename: `${imageId}.png`,
        directory: 'products'
      };
      
      await uploadImage(postData, file)
      image = `https://assets.catch-value.com/products/${imageId}.png`
    }

    const productDetails = await add({
      variables: {
        update_columns: ["id", ...Object.keys(rest)],
        objects: [
          {
            ...rest,    
            onboard_status: productOnboardStatus.PENDING,
            specifications: {
              data: specsArray,
              on_conflict: {
                constraint: 'specifications_product_id_key_key',
                update_columns: ['value']
              }
            }    
          },
        ],
      },
    });

    if(!editMode){
      const product_id = productDetails.data.buyer_db.insert_products.returning[0].id
      const imageValues = {
        product_id,
        uri: image,
        name: values.label

      }
      addProductImages({
        variables: {
          update_columns: ["id", ...Object.keys(imageValues)],
          objects: [
            {
              ...imageValues
            },
          ],
        },
      });   
    }
  };

  const headerEvents = (eventName) => {    
    refetch()
  }

  const failedSubmitHandler = (values) => {
    setFormLoading(false);
    notification["error"]({
      message: "Something went wrong!",
      description: "Please input values on required fields.",
    });
  };

  const cancelHandler = () => {
    history.push(`/wholesale/product-list`)
  }

  const [state, setState] = useState({
    showKg: false,
    showProduceType: false,
    showProduceEnvironment: false,
    showProductSubCat: false,
    showProductSizing: false,
    showProcessCat: false,
    showInventoryPostGrp: false,
    showSpecies: false,
    chosenSpecies: null
  })

  const [itemCodes, setItemCodes] = useState({
		product_type: {
      code: '',
      description: ''
    },
		product_environment: {
      code: '',
      description: ''
    },
		product_sub_category: {
      code: '',
      description: ''
    },
		label: {
      code: '',
      description: ''
    },
		product_size: {
      code: '',
      description: ''
    },
		process_category: {
      code: '',
      description: ''
    }
	})

  const [warningMessage, setWarningMessage] = useState()

  const showModal = (field) => {
    switch (field) {
      case "unit_of_measurement":
        setState({ ...state, showKg: true, fieldKey: 'unit_of_measure' })
        break;
      case "purchase_unit_of_measure":
        setState({ ...state, showKg: true, fieldKey: ['species_replenishments', 'purchase_unit_of_measure'] })
        break;
      case "product_type":
        setState({ ...state, showProduceType: true })
        break;
      case "product_environment":
        setState({ ...state, showProduceEnvironment: true })
        break;
      case "product_sub_category":
        setState({ ...state, showProductSubCat: true })
        break;
      case "product_sizing":
        setState({ ...state, showProductSizing: true })
        break;
      case "process_category":
        setState({ ...state, showProcessCat: true })
        break;
      case "gen_prod_posting_group":
        setState({ ...state, showGenProdPostGrp: true })
        break;
      case "inventory_posting_group":
        setState({ ...state, showInventoryPostGrp: true })
        break;
      case "gst_group_code":
        setState({ ...state, showGstProdPostGrp: true })
        break;
      case "species_id":
        setState({ ...state, showSpecies: true })
        break;
      default:
        break;
    }
  }

  const setFieldValue = (key, value, code) => {
    if (!Array.isArray(key)) form.setFieldsValue({ ...form.getFieldsValue(), [key]: value })
    else form.setFieldsValue({
      ...form.getFieldsValue(),
      [key[0]]: {
        ...form.getFieldsValue()?.[key[0]],
        [key[1]]: value
      }
    })

    if (code !== undefined){
      let str = ''
      if (!Array.isArray(code)){
        setItemCodes({ ...itemCodes, [key]: {
          code,
          description: value
        }})
        const newItemCode = { ...itemCodes, [key]: {
          code,
          description: value
        }}
        
        const codeValues = Object.values(newItemCode).map(({code}) => code?.slice(0, 3).toUpperCase());
        str = codeValues.filter(x => x !== '' && x !== undefined).join('-') + '-B2B';
        form.setFieldsValue({ sku: str })
      } else {
        const keys = Object.keys(itemCodes);
        const newObject = {};
        for (let i = 0; i < keys.length; i++) {
          let prop = keys[i]
          newObject[prop] = {}
          newObject[prop].code = code[i]?.code ? code[i].code : code[i]
          newObject[prop].description = code[i]?.description ? code[i].description : code[i]
        }
        setItemCodes(newObject)
        
        const codeValues = Object.values(newObject).map(({code}) => code?.slice(0, 3).toUpperCase());
        str = codeValues.filter(x => x && x !== '').join('-')+ '-B2B';
        form.setFieldsValue({ sku: str })
        setWarningMessage(str)
      }
      handleItemCodeValidation(str)
    }
  }

  const handleInputChange = async (event) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith('image/')) {
      setImg(URL.createObjectURL(file))
    }

  }

  const onClickHere = (itemCodeId) => {
    history.push(`/wholesale/product-list/new/edit/${itemCodeId}`, { prevPath: '/wholesale/product-list' } )
    window.location.reload()
  }

  const handleItemCodeValidation = (currentItemCode) => {

    const previousItemCode = data?.buyer_db.products?.[0].sku ?? null    
    const itemCodeId = allProducts.find(obj => obj.sku === currentItemCode)?.id ?? null;

    let compare = previousItemCode === currentItemCode

    if(!editMode){
      if(itemCodeId && !compare){
        setWarningMessage({
          id: itemCodeId,
          help: <span>This product already exists. Click <a onClick={() => onClickHere(itemCodeId)}>here</a> to update this product instead.</span>,
          validateStatus: 'warning'
        })
      }
      else if (!itemCodeId){
        setWarningMessage({})
      }
    }

    if (editMode){
      if(!itemCodeId && !compare){
        setWarningMessage({
          id: null,
          help: <span>Item code is updated. This will be saved as a new product.</span>,
          validateStatus: 'warning'
        })
      }
      else if(itemCodeId && !compare){
        setWarningMessage({
          id: itemCodeId,
          help: <span>This product already exists. Click <a href={editMode ? itemCodeId : `edit/${itemCodeId}`}>here</a> to update this product instead.</span>,
          validateStatus: 'warning'
        })
      }
    }
  }
  
  return (
    <Container>
      <ChooseUom state={state} setState={setState} setFieldValue={setFieldValue} />
      <ChooseProduceType state={state} setState={setState} setFieldValue={setFieldValue} />
      <ChooseProductEnvironment state={state} setState={setState} setFieldValue={setFieldValue} />
      <ChooseProduceSubCat state={state} setState={setState} setFieldValue={setFieldValue} setCategory={setCategory} />
      <ChooseProduceSizing state={state} setState={setState} setFieldValue={setFieldValue} />
      <ChooseProcessCat state={state} setState={setState} setFieldValue={setFieldValue} />
      <ChooseGenProdPostGrp state={state} setState={setState} setFieldValue={setFieldValue} />
      <ChooseInventoryPostingGroup state={state} setState={setState} setFieldValue={setFieldValue} />
      <ChooseGstProdPostGrp state={state} setState={setState} setFieldValue={setFieldValue} />
      <ChooseSpecies state={state} setState={setState} setFieldValue={setFieldValue} setImage={setImg} setCategory={setCategory}/>
      <CardHeader editMode={editMode} label={`${data?.buyer_db.products[0].sku} | ${data?.buyer_db.products[0].label}`} onboardStatus={data?.buyer_db.products[0].onboard_status} pid={data?.buyer_db.products[0].id} onEvent={headerEvents}/>

      <Form
        form={form}
        name="vendorForm"
        onFinish={submitHandler}
        onFinishFailed={failedSubmitHandler}
      >
        <Section title="General">
          <div className="division">
            <Form.Item style={{ display: 'none' }} label="id" name={"id"} >
              <Input />
            </Form.Item>
            <Form.Item label="Item Code" name="sku"
              help = {warningMessage?.help}
              validateStatus = {warningMessage?.validateStatus}
            >
              <Input readOnly placeholder="Auto generated" />
            </Form.Item>
            <Form.Item label="Item Description" name="label" rules={[{ required: true, message: '' }]}>
              <Input />
            </Form.Item>
            <Form.Item
              name="status"
              label="Blocked"
              valuePropName="checked"
              initialValue={false}
            >
              <Switch />
            </Form.Item>
            <Form.Item label="Item Type" name="item_type" initialValue="B2B">
              <Select>
                <Select.Option value="B2B">
                  B2B
                </Select.Option>
                {/* <Select.Option value="service">
                  Service
                </Select.Option>
                <Select.Option value="non-inventory">
                  Non-inventory
                </Select.Option> */}
              </Select>
            </Form.Item>
            <Form.Item style={{ display: 'none' }} label="Species" name="species_id">
              <Input />
            </Form.Item>
            <Form.Item label="Species" name="species_name" rules={[{ required: true, message: '' }]}>
              <Input onClick={() => showModal("species_id")} />
            </Form.Item>
            <Form.Item label="Remarks" name="remarks">
              <TextArea />
            </Form.Item>
          </div>

          <div className="division">
            <Form.Item
              label="Unit of measurement"
              name="unit_of_measure"
              rules={[{ required: true, message: '' }]}
            >
              <Input onClick={() => showModal("unit_of_measurement")} />
            </Form.Item>
            <Form.Item value="ok" label="Produce Type" name="produce_type" rules={[{ required: true, message: '' }]} >
              <Input onClick={() => {showModal("product_type")}} />
            </Form.Item>
            <Form.Item
              label="Produce Environment"
              name="produce_environment" rules={[{ required: true, message: '' }]}
            >
              <Input onClick={() => showModal("product_environment")} />
            </Form.Item>
            <Form.Item
              label="Product Sub Category"
              name="product_sub_category" rules={[{ required: true, message: '' }]}
            >
              <Input onClick={() => showModal("product_sub_category")} />
            </Form.Item>
            <Form.Item label="Produce Sizing" name="produce_sizing" rules={[{ required: true, message: '' }]}>
              <Input onClick={() => showModal("product_sizing")} />
            </Form.Item>
            <Form.Item
              label="Common Item No."
              name="common_item_no"
            >
              <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item
              label="Process Category"
              name="process_category"
              rules={[{ required: true, message: '' }]}
            >
              <Input onClick={() => showModal("process_category")} />
            </Form.Item>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div style={{ marginRight: 100 }}>Add Pictures</div>
              <div style={{ display: "flex" }}>
                {img && <img src={img} alt="" style={{ height: 70, width: 70, marginRight: 10 }} />}
                <label for="upload-photo" style={{ display: "flex", backgroundColor: "#D9E3F3", alignItems: "center", justifyContent: "center" }}>
                  <PlusOutlined style={{ fontSize: 70, color: "#90ABDD" }} size={100} color="red" />
                </label>
                <input type="file" ref={imageRef} onChange={handleInputChange} id="upload-photo" style={{ display: "none" }} />
              </div>
            </div>

          </div>
        </Section>

        
        {category && <Section title="Specification">
        {category === 'Fish' && (
          <>
            <div className="division">
              <Form.Item
                label="Format"
                name={['specifications', 'format']}
                rules={[{ required: true, message: '' }]}
              >
                <Select placeholder="Select format">
                  {(dropdowns["Format"] || []).map((value) => (
                    <Option key={value} value={value}>
                      {value}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="Scientific Name"
                name={['specifications', 'scientific_name']}
                rules={[{ required: true, message: '' }]}
              >
                <Input placeholder="Enter name" />
              </Form.Item>

              <Form.Item label="Temperature (°C)">
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <Form.Item
                    name={['specifications', 'min_temp']}
                    noStyle
                    rules={[{ required: true, message: '' }]}
                  >
                    <Input placeholder="Min" style={{ width: '40%' }} />
                  </Form.Item>
                  <span style={{ margin: '0 10px' }}>to</span>
                  <Form.Item
                    name={['specifications', 'max_temp']}
                    noStyle
                    rules={[{ required: true, message: '' }]}
                  >
                    <Input placeholder="Max" style={{ width: '40%' }} />
                  </Form.Item>
                </div>
              </Form.Item>
            </div>

            <div className="division">
              <Form.Item label="Weight Range per piece (g)">
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <Form.Item
                    name={['specifications', 'min_weight']}
                    noStyle
                    rules={[{ required: true, message: '' }]}
                  >
                    <Input placeholder="Min" style={{ width: '40%' }} />
                  </Form.Item>
                  <span style={{ margin: '0 10px' }}>to</span>
                  <Form.Item
                    name={['specifications', 'max_weight']}
                    noStyle
                    rules={[{ required: true, message: '' }]}
                  >
                    <Input placeholder="Max" style={{ width: '40%' }} />
                  </Form.Item>
                </div>
              </Form.Item>

              <Form.Item
                label="Max time from Harvest (hr)"
                name={['specifications', 'time_harvest']}
                rules={[{ required: true, message: '' }]}
              >
                <Input placeholder="e.g. 24" />
              </Form.Item>

              <Form.Item
                label="Catch Method"
                name={['specifications', 'harvest_method']}
                rules={[{ required: true, message: '' }]}
              >
                <Select placeholder="Select catch method">
                  {(dropdowns["Catch Method"] || []).map((value) => (
                    <Option key={value} value={value}>
                      {value}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
          </>
        )}

        {category === 'Non Fish' && (
          <>
            <div className="division">
              <Form.Item
                label="Format"
                name={['specifications', 'format']}
                rules={[{ required: true, message: '' }]}
              >
                <Select placeholder="Select format">
                  {(dropdowns["Format"] || []).map((value) => (
                    <Option key={value} value={value}>
                      {value}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="Scientific Name"
                name={['specifications', 'scientific_name']}
                rules={[{ required: true, message: '' }]}
              >
                <Input placeholder="Enter name" />
              </Form.Item>

              <Form.Item label="Temperature (°C)">
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <Form.Item
                    name={['specifications', 'min_temp']}
                    noStyle
                    rules={[{ required: true, message: '' }]}
                  >
                    <Input placeholder="Min" style={{ width: '40%' }} />
                  </Form.Item>
                  <span style={{ margin: '0 10px' }}>to</span>
                  <Form.Item
                    name={['specifications', 'max_temp']}
                    noStyle
                    rules={[{ required: true, message: '' }]}
                  >
                    <Input placeholder="Max" style={{ width: '40%' }} />
                  </Form.Item>
                </div>
              </Form.Item>

              <Form.Item
                label="Grade"
                name={['specifications', 'grade']}
                rules={[{ required: true, message: '' }]}
              >
                <Select placeholder="Select Grade">
                  {(dropdowns["Grade"] || []).map((value) => (
                    <Option key={value} value={value}>
                      {value}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="Glaze (%)"
                name={['specifications', 'glaze']}
                rules={[{ required: true, message: '' }]}
              >
                <Input placeholder="%" />
              </Form.Item>
            </div>

            <div className="division">
              <Form.Item label="Count (pc/lb)">
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <Form.Item
                    name={['specifications', 'min_count']}
                    noStyle
                    rules={[{ required: true, message: '' }]}
                  >
                    <Input placeholder="Min" style={{ width: '40%' }} />
                  </Form.Item>
                  <span style={{ margin: '0 10px' }}>to</span>
                  <Form.Item
                    name={['specifications', 'max_count']}
                    noStyle
                    rules={[{ required: true, message: '' }]}
                  >
                    <Input placeholder="Max" style={{ width: '40%' }} />
                  </Form.Item>
                </div>
              </Form.Item>

              <Form.Item
                label="Count Type"
                name={['specifications', 'count_type']}
                rules={[{ required: true, message: '' }]}
              >
                <Select placeholder="Select Count Type">
                  {(dropdowns["Count Type"] || []).map((value) => (
                    <Option key={value} value={value}>
                      {value}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="Processing Type"
                name={['specifications', 'processing_type']}
                rules={[{ required: true, message: '' }]}
              >
                <Select placeholder="Select Processing Type">
                  {(dropdowns["Processing Type"] || []).map((value) => (
                    <Option key={value} value={value}>
                      {value}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="Pouch Weight (KG)"
                name={['specifications', 'pouch_weight']}
                rules={[{ required: true, message: '' }]}
              >
                <Input placeholder="KG" />
              </Form.Item>

              <Form.Item
                label="Master Carton Weight (KG)"
                name={['specifications', 'carton_weight']}
                rules={[{ required: true, message: '' }]}
              >
                <Input placeholder="KG" />
              </Form.Item>

            </div>
          </>
        )}

        </Section>}

        <Section title="Inventory">
          <div className="division">
            <Form.Item style={{ display: 'none' }} label="id" name={["species_inventories", "id"]}>
              <Input />
            </Form.Item>
            <Form.Item
              label="Location No."
              name={["species_inventories", "location_no"]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Inventory"
              name={["species_inventories", "inventory"]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Quantity on Purch Order"
              name={[
                "species_inventories",
                "quantity_on_purchase_order",
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Quantity on Sales Order"
              name={[
                "species_inventories",
                "quantity_on_sales_order",
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Quantity on Job Order"
              name={[
                "species_inventories",
                "quantity_on_job_order",
              ]}
            >
              <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item
              label="Quantity on Assembly Order"
              name={[
                "species_inventories",
                "quantity_on_assembly_order",
              ]}
            >
              <Input />
            </Form.Item>
          </div>
          <div className="division">
            <Form.Item
              label="Qty. on Asm. Component"
              name={[
                "species_inventories",
                "quantity_on_asm_component",
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Stock out Warning"
              name={["species_inventories", "stock_out_warning"]}
            >
              <Select>
                <Select.Option value="yes">Yes</Select.Option>
                <Select.Option value="no">No</Select.Option>
              </Select>
            </Form.Item>
            <Form.Item
              label="Net Weight"
              name={["species_inventories", "net_weight"]}
            >
              <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item
              label="Gross Weight"
              name={["species_inventories", "gross_weight"]}
            >
              <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item
              label="Unit Volume"
              name={["species_inventories", "unit_volume"]}
            >
              <InputNumber style={{ width: '100%' }} />
            </Form.Item>
          </div>
        </Section>

        <CommonDiv direction="row" justify="flex-end">
          <ButtonLoader loading={formLoading} htmlType="submit" disabled={warningMessage?.id}>
            {editMode ? "Update" : "Save"}
          </ButtonLoader>
          <CommonButton className='reverse' onClick={cancelHandler} >Cancel</CommonButton>
        </CommonDiv>
      </Form>
    </Container>
  );
}

WholesaleNewProductPage.propTypes = {};

export default WholesaleNewProductPage
